export const ROUTE_LOGIN = 'ROUTE_LOGIN'
export const ROUTE_LOGIN_FORM = 'ROUTE_LOGIN_FORM'
export const ROUTE_ME = 'ROUTE_ME'
export const ROUTE_HELP = 'ROUTE_HELP'
export const ROUTE_CONTROLS = 'ROUTE_CONTROLS'
export const ROUTE_LIST = 'ROUTE_LIST'
export const ROUTE_LIST_PAGE = 'ROUTE_LIST_PAGE'
export const ROUTE_LIST_PROJECT = 'ROUTE_LIST_PROJECT'
export const ROUTE_LIST_CURRENT_USER = 'ROUTE_LIST_CURRENT_USER'
export const ROUTE_CARD = 'ROUTE_CARD'
export const ROUTE_CARD_PEEK = 'ROUTE_CARD_PEEK'
export const ROUTE_CARD_DETAILS = 'ROUTE_CARD_DETAILS'
export const ROUTE_CARD_COMMENTS = 'ROUTE_CARD_COMMENTS'
export const ROUTE_CARD_FILES = 'ROUTE_CARD_FILES'
export const ROUTE_CARD_PAGES = 'ROUTE_CARD_PAGES'
export const ROUTE_CARD_BROWSERS = 'ROUTE_CARD_BROWSERS'

export const CARD_CREATE = 'CARD_CREATE'

export const CARD_MODE_GENERIC = 'CARD_MODE_GENERIC'
export const CARD_MODE_SNAPSHOT = 'CARD_MODE_SNAPSHOT'

export const PROVIDER_LOCAL = 'PROVIDER_LOCAL'

export const APP_MODE_SPACE = 'APP_MODE_SPACE'
export const APP_MODE_SITE = 'APP_MODE_SITE'
